/* global angular, moment */
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.cart.factory:Cart
   *
   * @description
   *
   */
  angular
    .module('vcfinance.cart')
    .factory('Cart', Cart);


  Cart.$inject = ['$http', '$log'];

  function Cart($http, $log) {
    let service = {};
    service.getCart = getCart;
    service.addItem = addItem;
    service.updateItem = updateItem;
    service.removeItem = removeItem;
    service.setDiscount = setDiscount;
    service.setDiagnoses = setDiagnoses;
    service.setTimeframe = setTimeframe;
    service.getCount = getCount;

    function getCart(patid) {
      return $http.get(`/routes/carts/${patid}/getcart`);
    }

    function addItem(patid, item) {
      return $http.post(`/routes/carts/${patid}/additem`, item);
    }

    function updateItem(patid, item) {
      return $http.post(`/routes/carts/${patid}/updateitem`, item);
    }

    function removeItem(patid, item) {
      return $http.post(`/routes/carts/${patid}/deleteitem`, item);
    }

    function setDiscount(patid, discount) {
      return $http.post(`/routes/carts/${patid}/setdiscount`, discount);
    }

    function setDiagnoses(patid, diagnoses) {
      return $http.post(`/routes/carts/${patid}/setdiagnoses`, diagnoses);
    }


    function setTimeframe(patid, timeframe) {
      return $http.post(`/routes/carts/${patid}/settimeframe`, timeframe);
    }

    function getCount(patid, item) {
      return $http.get(`/routes/carts/${patid}/getcount`);
    }

    return service;

  }

/*
  let newprivcatitem = {
    "_id": "5a672d9a1f16225102273d84",
    "created": "2018-01-23T12:42:02.326Z",
    "active": true,
    "type": "entry",
    "repeatable": true,
    "tax": 0,
    "svs": {"bva": "bvaO1", "sva": "svaO1", "vaeb": "vaebO1", "wgkk": "wgkkO1", "noegkk": "noegkkO1", "bgkk": "bgkkO1"},
    "shortcut": "O1",
    "name": "Erstordination 45Min",
    "details": "foobar",
    "price": 160
  };*/
  /*
   alte rechungstruktur
   let foo = {
      "_id": "5748a6eb7c01596daef2254c",
      "date": "2016-05-27T19:57:55.105Z",
      "fdate": "27. Mai 2016",
      "ftime": "21:57:55",
      "storno": false,
      "test": false,
      "items": [{
        "_id": "5748a65c7c01596daef22539",
        "created": "2016-05-27T19:56:13.608Z",
        "active": true,
        "name": "Erste Ordination (BVA etc)",
        "price": 70,
        "details": "Erste Ordination E1",
        "num": 5,
        "cat": "Priv",
        "include": true
      }],
      "netto": 70,
      "tax": 0,
      "total": 70,
      "paytype": "cash",
      "paid": true,
      "type": "Barrechnung",
      "cash": true,
      "paiddate": "2016-05-27T19:57:55.105Z",
      "invoicenr": "B22",
      "receiptnr": "21",
      "patientinvoiceid": "5748a6d07c01596daef22544",
      "doctorinvoiceid": "5748a6d97c01596daef22546",
      "receiptid": "5748a6da7c01596daef22548",
      "patientid": "573410687c01597c1aa2178d",
      "consultid": "5748a6737c01596daef2253a",
      "finished": false,
      "nettodiscounted": 70,
      "taxdiscounted": 0,
      "discount": 0,
      "totalbefore": 70
    }*/


  // Cart.$inject = ['restmod'];
  /*function Cart(restmod) {
    return restmod.model('/routes/carts').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/carts/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $addEntryOrGroup: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                // console.log('*************** restmod additem _params', _params);// => _params = {clientid: "a234b234.."}
                let url = '/routes/carts/' + _params.clientid + '/additem';
                _req.method = 'POST';
                _req.url = url;
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $getCart: function (id) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                console.log('*************** restmod getcart _params', _params);
                let url = '/routes/carts/' + _params + '/getcart';
                _req.method = 'GET';
                _req.url = url;
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return $search({key, val});
          }
        } // Model
      }// extend
    });
  }*/

// klammerfriedhof
}());
